import { render, staticRenderFns } from "./LoginNamu.vue?vue&type=template&id=90a0070e&scoped=true"
import script from "./LoginNamu.vue?vue&type=script&lang=js"
export * from "./LoginNamu.vue?vue&type=script&lang=js"
import style0 from "./LoginNamu.vue?vue&type=style&index=0&id=90a0070e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a0070e",
  null
  
)

export default component.exports